import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { SellingConfigurationEntity } from "./domain/sellingConfiguration.entity";
import { BooleanRenderer, mapRenderer, StringRenderer } from "../shared/renderers/table";

export default function getTableColumns(intl: IntlShape): TableColumns<SellingConfigurationEntity> {
  return {
    active: {
      renderer: BooleanRenderer,
    },
    id: {
      renderer: StringRenderer,
    },
    sellingLocations: {
      renderer: mapRenderer(StringRenderer, v => {
        return v.join(", ");
      }),
    },
  };
}
